import type { SxProps, Theme } from '@mui/material';

export const styles = {
    adornment: {
        mr: 0.5,
        color: 'inherit',
        '& .MuiTypography-root': {
            color: 'inherit',
            fontSize: 'inherit',
        },
    } as SxProps<Theme>,
};
